export default "__VITE_ASSET__BK84QP1$__"